import { CanMatchFn, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { LayoutMaintenanceComponent } from './components/layout/layout-maintenance/layout-maintenance.component';
import { LayoutLoginComponent } from './components/layout/layout-login/layout-login.component';
import { LoginComponent } from './components/login/login.component';
import FetrapiEnums from './share/enum/enums';
import { Layout2Component } from './components/layout/layout-2/layout-2.component';
import { AuthGuard } from './share/guard/auth.guard';
import { RoleGuard } from './share/guard/role.guard';
import { GriddataComponent } from './components/griddata/griddata.component';
import { ZoidataComponent } from './components/zoidata/zoidata.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { ConsolidationComponent } from './components/consolidation/consolidation.component';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { ApprovalComponent } from './components/approval/approval.component';
import { LoggerComponent } from './components/logger/logger.component';
import { MapComponent } from './components/map/map.component';
import { MembersComponent } from './components/members/members.component';
import { inject } from '@angular/core';
import { ConfigService } from './share/services/config.service';


const canMatchActive: CanMatchFn = (): boolean => {
	const config = inject(ConfigService);
  const isActiveEnvironment = config.getEnv('fetrapiActiveEnvironment');
  return JSON.parse(isActiveEnvironment as string);
}
const canMatchInactive: CanMatchFn = (): boolean => {
	const config = inject(ConfigService);
  const isActiveEnvironment = config.getEnv('fetrapiActiveEnvironment');
  return !JSON.parse(isActiveEnvironment as string);
}
//All Routes: active and inactive are separated by canMatch functions
export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canMatch: [canMatchActive]
  },
  {
    path: 'login',
    component: LayoutLoginComponent,
    canMatch: [canMatchActive],
    children: [{ path: '', component: LoginComponent }],
  },
  {
    path: 'map',
    component: Layout2Component,
    canActivate: [AuthGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: MapComponent }],
  },
  {
    path: 'log',
    component: Layout2Component,
    canActivate: [AuthGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: LoggerComponent }],
  },
  {
    path: 'members',
    component: Layout2Component,
    data: { roles: [FetrapiEnums.MainGroups.FetrapiAdmin] },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: MembersComponent }],
  },
  {
    path: 'approval',
    component: Layout2Component,
    data: { roles: [FetrapiEnums.MainGroups.FetrapiAdmin] },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: ApprovalComponent }],
  },
  {
    path: 'grid',
    component: Layout2Component,
    data: {
      roles: [
        FetrapiEnums.MainGroups.FetrapiMember,
        FetrapiEnums.MainGroups.FetrapiAdmin,
      ],
    },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: GriddataComponent }],
  },
  {
    path: 'zoi',
    component: Layout2Component,
    data: {
      roles: [
        FetrapiEnums.MainGroups.ChIIIMember,
        FetrapiEnums.MainGroups.ADCRMember,
      ],
    },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: ZoidataComponent }],
  },
  {
    path: 'confirmation',
    component: Layout2Component,
    data: { roles: [FetrapiEnums.MainGroups.FetrapiAdmin] },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: ConfirmationComponent }],
  },
  {
    path: 'consolidation',
    component: Layout2Component,
    data: { roles: [FetrapiEnums.MainGroups.FetrapiAdmin] },
    canActivate: [AuthGuard, RoleGuard],
    canMatch: [canMatchActive],
    children: [{ path: '', component: ConsolidationComponent }],
  },
  {
    path: 'downloads',
    component: Layout2Component,
    canMatch: [canMatchActive],
    children: [{ path: '', component: DownloadsComponent }],
  },
  // 404 Not Found page
  {
    path: '**',
    component: Layout2Component,
    canMatch: [canMatchActive],
    children: [{ path: '', component: NotFoundComponent }],
  },
  {
    path: 'maintenance',
    component: LayoutMaintenanceComponent,
    canMatch: [canMatchInactive],
    children: [{ path: '', component: MaintenanceComponent }],
  },
  {
    path: 'login',
    component: LayoutLoginComponent,
    canMatch: [canMatchInactive],
    children: [{ path: '', component: LoginComponent }],
  },
  {
    path: '**',
    component: HomeComponent,
    canMatch: [canMatchInactive],
    pathMatch: 'full',
  },
];

// *******************************************************************************
//

